import React, { useEffect, useState } from 'react'
import Loader from '../../../../components/Loader';
import { Helmet } from 'react-helmet';
import Header from '../../../../layout/header/Header';
import { Box, Grid, Typography } from '@mui/material';
import { applicantCountConstant, BOOKING_AS, BOOKING_FORM_STATUS, COMPARE_VALUE } from '../../../../config/constant';
import { Cards } from './components/Cards';
import { ReviewDetailsWrapper } from '../ReviewDetails/ReviewDetailsWrapper';
import ReviewInput from '../../../../components/ReviewInput';
import UploadPopup from '../../../../shared-components/upload-popup/UploadPopup';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import { getApplicantDetails, getOppprtunityDetails, setEntity, setIsCorporateFlow } from '../../new-booking-form.slice';
import UploadPopupTwoImages from '../../../../shared-components/upload-popup/UploadPopupTwoImages';
import { handlePayment, toTitleCase } from '../../../../utilis/common-funtions';

const KYCDocumentsPage = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { oppId } = useParams();
  const [openPopup, setOpenPopup] = useState(null);
  const [fieldName, setFieldName] = useState("");
  const [companyData, setCompanyData] = useState({});
  const [authorizedSignatory, setAuthorizedSignatory] = useState([]);
  const [paymentDetails, setPaymentDetails] = useState([]);
  const { isLoading, applicantData, entity } = useSelector((state) => state.newBookingForm);
  const isKYCDocumentsNotUploaded = BOOKING_FORM_STATUS?.NOT_SENT === applicantData?.bookingFormStatus ||
    BOOKING_FORM_STATUS?.IN_PROGRESS === applicantData?.bookingFormStatus ||
    BOOKING_FORM_STATUS?.SENT === applicantData?.bookingFormStatus

  useEffect(() => {
    const fetchOpportunityAndApplicant = async () => {
      if (!oppId?.length) return;

      try {
        await dispatch(getOppprtunityDetails(`/${oppId}`)).unwrap();
        const res = await dispatch(getApplicantDetails(`/${oppId}`)).unwrap();

        if (res?.bookingAs) {
          dispatch(setIsCorporateFlow(res?.bookingAs === BOOKING_AS.CORPORATE));
          dispatch(
            setEntity(
              res?.bookingAs === BOOKING_AS.PARTNERSHIP_FIRM
                ? t("entity.firm")
                : t("entity.company")
            )
          );
        }

        if (isKYCDocumentsNotUploaded) {
          history.push("/404");
        } else {
          return
        }

      } catch (error) {
        history.push("/404");
      }
    };
    fetchOpportunityAndApplicant();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!applicantData) return;
    setCompanyData({
      name: applicantData?.companyDetails?.companyName,
      gstNumber: applicantData?.companyDetails?.gstNumber,
      gstCertificate: applicantData?.companyDetails?.documents?.gstCertificate,
      panNumber: applicantData?.companyDetails?.companyPan,
      panCard: applicantData?.companyDetails?.documents?.pan,
      incorporationCertificate: applicantData?.companyDetails?.documents?.incorporationCertificate,
      memorandumOfAssociation: applicantData?.companyDetails?.documents?.memorandumOfAssociation,
      articlesOfAssociation: applicantData?.companyDetails?.documents?.articlesOfAssociation,
      boardResolutionForPurchase: applicantData?.companyDetails?.documents?.boardResolutionPurchase,
      amountPaid: `₹${applicantData?.paymentDetails?.amount}`,
      partnershipDeed: applicantData?.companyDetails?.documents?.partnershipDeed,
      partnersResolution: applicantData?.companyDetails?.documents?.partnersResolution,
    });

    const list = [1, 2, 3, 4] // applicant1 → applicant4
      .map(num => applicantData[`applicant${num}`])
      .filter(Boolean) // removes null/undefined
      .map(applicant => ({
        passportPhoto: applicant?.personalDetails?.image || [],
        aadhaar: applicant?.personalDetails?.aadhaarImage || [],
        pan: applicant?.personalDetails?.panImage || [],
        passport: applicant?.personalDetails?.passportImage || [],
        oci: applicant?.personalDetails?.ociImage || [],
        aadhaarNumber: applicant?.personalDetails?.aadhaarNumber,
        panNumber: applicant?.personalDetails?.panNumber,
        passportNumber: applicant?.personalDetails?.passportNumber,
        ociNumber: applicant?.personalDetails?.ociNumber,
        salutation: applicant?.personalDetails?.salutation,
        firstName: applicant?.personalDetails?.firstName,
        lastName: applicant?.personalDetails?.lastName,
        hasContinuedAsMinor: applicant?.hasContinuedAsMinor,
        legalGuardianDoc: applicant?.personalDetails?.legalGuardianDoc,
        isPhysicalAadhaar: applicant?.personalDetails?.isPhysicalAadhaar,
        isPhysicalPan : applicant?.personalDetails?.isPhysicalPan,
        isPhysicalPassport : applicant?.personalDetails?.isPhysicalPassport,
        isPhysicalOCI : applicant?.personalDetails?.isPhysicalOCI,
        isPhysicalImage : applicant?.personalDetails?.isPhysicalImage,
        isPhysicalLegalGuardianDoc : applicant?.personalDetails?.isPhysicalLegalGuardianDoc,
      }));
    setAuthorizedSignatory(list);

    setPaymentDetails(
      applicantData?.payments?.map((p, idx) => ({
        id: p?.id,
        transactionNo: `${t("kycDocuments.labels.transaction")} ${idx + 1}`,
        amount: `₹${p?.paidAmount}`,
        mode: p?.paymentMode,
        chequeNumber: p?.paymentDetails?.transactionNumber,
        bankName: p?.paymentDetails?.method,
        paymentProof: p?.paymentDetails?.paymentProof,
        paymentDetails: p?.paymentDetails, 
        isPhysicalPaymentProof: p?.paymentDetails?.isPhysicalPaymentProof, 
      })) || []
    );
  }, [applicantData, t]);

  const cardData = [
    { title: t("kycDocuments.cardLabels.projectName"), value: applicantData?.unitDetails?.projectName || "N/A" },
    { title: t("kycDocuments.cardLabels.unitNumber"), value: applicantData?.unitDetails?.unitNumber || "N/A" },
    { title: t("kycDocuments.cardLabels.opportunityId"), value: applicantData?.opportunityId || "N/A" },
    { title: t("kycDocuments.cardLabels.closingRM"), value: applicantData?.closingRm?.name || "N/A" },
  ];

  const handleView = (name) => {
    setFieldName(name);
    setOpenPopup(true);
  };

  const getImageData = (fieldName) => {
    if (!fieldName) return [];
    const fromCompany = getNestedValue(companyData, fieldName);
    if (typeof fromCompany !== "undefined") return fromCompany || [];
    return getNestedValue({ authorizedSignatory, paymentDetails }, fieldName) || [];
  };

  const getNestedValue = (obj, path) => {
    return path
      .replace(/\[(\d+)\]/g, ".$1")
      .split(".")
      .reduce((acc, key) => (acc ? acc[key] : undefined), obj);
  };

  return (
    <>
      {isLoading && <Loader isLoading={isLoading} />}
      <div className="new-cp-form-container">
        <Helmet>
          <title>{t("bookingForm.kycTitle")}</title>
          <meta name="robots" content="noindex, nofollow" />
        </Helmet>
        <Header showHamburger={false} />
        <Grid
          container
          spacing={0}
          sx={{
            paddingLeft: {
              xs: "16px",
              sm: "16px",
              md: "16px",
              lg: "7%",
            },
            paddingRight: {
              xs: "16px",
              sm: "16px",
              md: "16px",
              lg: "7%",
            },
            py: { xs: "16px", sm: "30px", md: "36px" },
          }}
        >

          {cardData?.map((card, idx) => (
            <Grid item xs={12} sm={6} md={3} mb={3} key={idx}>
              <Cards title={card?.title} value={card?.value} />
            </Grid>
          ))}

          <Grid item xs={12}>
            <Box
              sx={{
                border: "1px solid rgba(26, 64, 125, 0.3)",
                borderRadius: "8px",
                p: 3,
              }}
            >
              {applicantData?.companyDetails !== null ? (
                <ReviewDetailsWrapper
                  heading={t("companyDetails.title", { entity })}
                  value={`${t("kycDocuments.labels.name")} - ${companyData?.name ? companyData?.name : "N/A"}`}
                >
                  {companyData?.gstCertificate?.length > 0 && (
                    <Grid item xs={12} sm={6} md={4} lg={4}>
                      <ReviewInput
                        text={`${t("kycDocuments.labels.gstNumber")}: ${companyData?.gstNumber ? companyData?.gstNumber : "N/A"}`}
                        name="gstCertificate"
                        onView={handleView}
                        disabled={!companyData?.gstCertificate?.length}
                      />
                    </Grid>
                  )}

                  {companyData.panCard?.length > 0 && (
                    <Grid item xs={12} sm={6} md={4} lg={4}>
                      <ReviewInput
                        text={`${t("commonLabels.panNumber")}: ${companyData.panNumber ? companyData.panNumber : "N/A"}`}
                        name="panCard"
                        onView={handleView}
                        disabled={!companyData.panCard?.length}
                      />
                    </Grid>
                  )}

                  {companyData.incorporationCertificate?.length > 0 && (
                    <Grid item xs={12} sm={6} md={4} lg={4}>
                      <ReviewInput
                        text={t("companyDocument.labels.incorporationCertificate")}
                        name="incorporationCertificate"
                        onView={handleView}
                        disabled={!companyData.incorporationCertificate?.length}
                      />
                    </Grid>
                  )}

                  {companyData.memorandumOfAssociation?.length > 0 && (
                    <Grid item xs={12} sm={6} md={4} lg={4}>
                      <ReviewInput
                        text={t("companyDocument.labels.memorandumofAssociation")}
                        name="memorandumOfAssociation"
                        onView={handleView}
                        disabled={!companyData.memorandumOfAssociation?.length}
                      />
                    </Grid>
                  )}

                  {companyData.articlesOfAssociation?.length > 0 && (
                    <Grid item xs={12} sm={6} md={4} lg={4}>
                      <ReviewInput
                        text={t("companyDocument.labels.articlesofAssociation")}
                        name="articlesOfAssociation"
                        onView={handleView}
                        disabled={!companyData.articlesOfAssociation?.length}
                      />
                    </Grid>
                  )}

                  {companyData.boardResolutionForPurchase?.length > 0 && (
                    <Grid item xs={12} sm={6} md={4} lg={4}>
                      <ReviewInput
                        text={t("companyDocument.labels.boardResolution")}
                        name="boardResolutionForPurchase"
                        onView={handleView}
                        disabled={!companyData.boardResolutionForPurchase?.length}
                      />
                    </Grid>
                  )}

                  {companyData.partnershipDeed?.length > 0 && (
                    <Grid item xs={12} sm={6} md={4} lg={4}>
                      <ReviewInput
                        text={t("companyDocument.labels.partnershipDeed")}
                        name="partnershipDeed"
                        onView={handleView}
                        disabled={!companyData.partnershipDeed?.length}
                      />
                    </Grid>
                  )}

                  {companyData.partnersResolution?.length > 0 && (
                    <Grid item xs={12} sm={6} md={4} lg={4}>
                      <ReviewInput
                        text={t("companyDocument.labels.partnersResolution")}
                        name="partnersResolution"
                        onView={handleView}
                        disabled={!companyData.partnersResolution?.length}
                      />
                    </Grid>
                  )}
                </ReviewDetailsWrapper>
              ) : null}

              {/* Authorized Signatory Section */}
              {authorizedSignatory?.length > 0 &&
                authorizedSignatory?.map((signatory, idx) => (
                  <ReviewDetailsWrapper
                    heading={
                      applicantData.bookingAs !== BOOKING_AS.INDIVIDUAL ? (<>
                        {idx + 1 > 1 && (
                          <>
                            {idx + 1}
                            <sup>{applicantCountConstant?.numberKeys[idx + 1]}</sup>{" "}
                          </>
                        )}
                        {t("kycDocuments.labels.authorizedSignatory")}
                      </>)
                        :
                        (<>
                          {idx === 0 ? (
                            t("preview.labels.primaryApplicant")

                          ) : (
                            <>
                              {idx + 1}
                              <sup>{applicantCountConstant?.numberKeys[idx + 1]}</sup>{" "}
                              {t("preview.labels.applicant")}
                              {signatory.hasContinuedAsMinor && `${t("minorDetails.labels.minor")}`}
                            </>

                          )}
                        </>)
                    }
                    value={
                      signatory?.salutation || signatory?.firstName || signatory?.lastName
                        ? `${t("kycDocuments.labels.name")} - ${signatory?.salutation || ""} ${signatory?.firstName || ""} ${signatory?.lastName || ""}`
                        : `${t("kycDocuments.labels.name")} - N/A`
                    }
                    key={idx}
                  >


                    {(signatory?.aadhaar?.length > 0 || signatory?.isPhysicalAadhaar) && (
                      <Grid item xs={12} sm={6} md={4} lg={4}>
                        <ReviewInput
                          text={`${t("commonLabels.aadhaarNumber")}: ${signatory?.aadhaarNumber ?? "N/A"}`}
                          name={`authorizedSignatory[${idx}].aadhaar`}
                          onView={handleView}
                          disabled={!signatory?.aadhaar?.length}
                          isPhysicalDoc={signatory?.isPhysicalAadhaar && signatory?.aadhaar?.length===0}
                          isKycPagePhysicalSubmited={signatory?.isPhysicalAadhaar && signatory?.aadhaar?.length===0}  
                        />
                      </Grid>
                    )}

                    {(signatory?.pan?.length > 0 || signatory?.isPhysicalPan) && (
                      <Grid item xs={12} sm={6} md={4} lg={4}>
                        <ReviewInput
                          text={`${t("commonLabels.panNumber")}: ${signatory?.panNumber ?? "N/A"}`}
                          name={`authorizedSignatory[${idx}].pan`}
                          onView={handleView}
                          disabled={!signatory?.pan?.length}
                          isPhysicalDoc={signatory?.isPhysicalPan && signatory?.pan?.length===0}
                          isKycPagePhysicalSubmited={signatory?.isPhysicalPan && signatory?.pan?.length===0} 
                        />
                      </Grid>
                    )}

                    {(signatory?.passport?.length > 0 || signatory?.isPhysicalPassport) && (
                      <Grid item xs={12} sm={6} md={4} lg={4}>
                        <ReviewInput
                          text={`${t("commonLabels.passportNumber")}: ${signatory?.passportNumber ?? "N/A"}`}
                          name={`authorizedSignatory[${idx}].passport`}
                          onView={handleView}
                          disabled={!signatory?.passport?.length}
                          isPhysicalDoc={signatory?.isPhysicalPassport && signatory?.passport?.length === 0}
                          isKycPagePhysicalSubmited={signatory?.isPhysicalPassport && signatory?.passport?.length===0} 
                        />
                      </Grid>
                    )}

                    {(signatory?.oci?.length > 0 || signatory?.isPhysicalOCI) && (
                      <Grid item xs={12} sm={6} md={4} lg={4}>
                        <ReviewInput
                          text={`${t("commonLabels.ociNumber")}: ${signatory?.ociNumber ?? "N/A"}`}
                          name={`authorizedSignatory[${idx}].oci`}
                          onView={handleView}
                          disabled={!signatory?.oci?.length}
                          isPhysicalDoc={signatory?.isPhysicalOCI && signatory?.oci?.length === 0}
                          isKycPagePhysicalSubmited={signatory?.isPhysicalOCI && signatory?.oci?.length===0}
                          
                        />
                      </Grid>
                    )}
                    
                    {(signatory?.passportPhoto?.length > 0 || signatory?.isPhysicalImage) && (
                      <Grid item xs={12} sm={6} md={4} lg={4}>
                        <ReviewInput
                          text={t("kycDocuments.labels.passportSizePhoto")}
                          name={`authorizedSignatory[${idx}].passportPhoto`}
                          onView={handleView}
                          disabled={!signatory?.passportPhoto?.length}
                          isPhysicalDoc={signatory?.isPhysicalImage && signatory?.passportPhoto?.length === 0}
                          isKycPagePhysicalSubmited={signatory?.isPhysicalImage && signatory?.passportPhoto?.length === 0}
                        />
                      </Grid>
                    )}

                    {(signatory?.legalGuardianDoc?.length > 0 || signatory?.isPhysicalLegalGuardianDoc) && (
                      <Grid item xs={12} sm={6} md={4} lg={4}>
                        <ReviewInput
                          text={t("kycDocuments.labels.legalGuardian")}
                          name={`authorizedSignatory[${idx}].legalGuardianDoc`}
                          onView={handleView}
                          disabled={!signatory?.legalGuardianDoc?.length}
                          isPhysicalDoc={signatory?.isPhysicalLegalGuardianDoc && signatory?.legalGuardianDoc?.length === 0}
                          isKycPagePhysicalSubmited={signatory?.isPhysicalLegalGuardianDoc && signatory?.legalGuardianDoc?.length === 0}
                        />
                      </Grid>
                    )}
                  </ReviewDetailsWrapper>
                ))}

              {/* Booking Amount Payment Details */}
              {paymentDetails?.length > 0 && (
                <ReviewDetailsWrapper
                  heading={t("kycDocuments.labels.paymentDetailsTitle")}
                  value={`${t("kycDocuments.labels.amountPaid")} - ${companyData.amountPaid ? companyData.amountPaid : "N/A"}`}
                  divider={false}
                >
                  {paymentDetails?.map((payment, idx) => {

                    const getPaymentLabel = () => {
                      if (payment?.paymentDetails?.chequeNumber)
                        return t("kycDocuments.labels.chequeNo");
                      if (payment?.transactionNumber)
                        return t("kycDocuments.labels.transactionId");
                      if (payment?.paymentDetails?.gatewayPaymentId)
                        return t("kycDocuments.labels.ddNo");
                      return t("kycDocuments.labels.transactionId");
                    }

                    const getPaymentValue = () =>
                      payment?.paymentDetails?.chequeNumber?.trim() ||
                      payment?.paymentDetails?.transactionNumber?.trim() ||
                      payment?.paymentDetails?.gatewayPaymentId?.trim() ||
                      "N/A";

                    return (
                      <Grid item xs={12} key={idx}>
                        <Box
                          key={idx}
                          sx={{
                            mb: 3,
                            p: 2,
                            border: "1px solid #DADADA",
                            borderRadius: 2,
                          }}
                        >
                          <Grid container rowSpacing={3} columnSpacing={10}>
                            <Grid item xs={12} sm={6} md={4} lg={4}>
                              <Typography variant="body2" sx={{ fontWeight: 700 }}>
                                {payment.transactionNo}
                              </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={4}>
                              <Typography variant="body2" sx={{ fontWeight: 700 }}>
                                {t("kycDocuments.labels.transactionMode")}: &nbsp;{payment?.mode ? handlePayment(payment.mode) : "N/A"}

                              </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={4}></Grid>
                            <Grid item xs={12} sm={6} md={4} lg={4}>
                              <Typography variant="body2">
                                {getPaymentLabel()}:&nbsp;
                                <span style={{ fontWeight: 600 }}>{getPaymentValue()}</span>
                              </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={4}>
                              <Typography variant="body2">
                                {t("kycDocuments.labels.drawnOn")}:&nbsp;&nbsp;
                                <span style={{ fontWeight: 600 }}>
                                  {payment?.bankName?.toLowerCase().includes("upi") ? "UPI" : toTitleCase(payment?.bankName || "N/A")}
                                </span>

                              </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={4}>
                              <Typography variant="body2">
                                {t("corporatePaymentOption.paymentOptionForm.amount")}:&nbsp;&nbsp;
                                <span style={{ fontWeight: 600 }}>
                                  {payment.amount ? payment.amount : "N/A"}
                                </span>
                              </Typography>
                            </Grid>
                            {(payment?.paymentProof?.length > 0 || payment?.isPhysicalPaymentProof) && (
                              <Grid item xs={12} sm={6} md={4} lg={4}>
                                <ReviewInput
                                  text={t("corporatePaymentOption.paymentOptionForm.paymentProofLabel")}
                                  name={`paymentDetails[${idx}].paymentProof`}
                                  onView={handleView}
                                  disabled={!payment?.paymentProof?.length}
                                  isPhysicalDoc={payment?.isPhysicalPaymentProof && payment?.paymentProof?.length === 0}
                                  isKycPagePhysicalSubmited={payment?.isPhysicalPaymentProof && payment?.paymentProof?.length === 0}
                                />
                              </Grid>)}
                          </Grid>
                        </Box>
                      </Grid>
                    )
                  }
                  )}
                </ReviewDetailsWrapper>
              )}
            </Box>
          </Grid>
          {openPopup && (
            fieldName.includes("aadhaar") ? (
              // Aadhaar special handling
              getImageData(fieldName)[0]?.toLowerCase().endsWith(".pdf") ? (
                <UploadPopup
                  heading={t("button.view")}
                  totalImages={1}
                  closePopup={() => setOpenPopup(false)}
                  uploadedImage={getImageData(fieldName)}
                  fieldName={fieldName}
                  hidePhysicalCopyOption
                  dynamicSize={1}
                  hideCameraOption={false}
                  showDeleteIcon={false}
                />
              ) : (
                <UploadPopupTwoImages
                  heading={t("button.view")}
                  totalImages={getImageData(fieldName)?.length}
                  closePopup={() => setOpenPopup(false)}
                  uploadedImageFront={getImageData(fieldName)[0] || null}
                  uploadedImageBack={getImageData(fieldName)[1] || null}
                  fieldName={fieldName}
                  hidePhysicalCopyOption
                  dynamicSize={1}
                  showDeleteIcon={false}
                  showPreview={true}
                />
              )
            ) : (
              // Default case for all other docs
              <UploadPopup
                heading={t("button.view")}
                totalImages={1}
                closePopup={() => setOpenPopup(false)}
                uploadedImage={getImageData(fieldName)}
                fieldName={fieldName}
                hidePhysicalCopyOption
                dynamicSize={1}
                hideCameraOption={false}
                showDeleteIcon={false}
              />
            )
          )}
        </Grid>
      </div>
    </>
  );
}

export default KYCDocumentsPage